interface CronosIconProps {
  className?: string
}

export function CronosIcon({ className }: CronosIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120.1 138.8" className={className}>
      <path
        fill="#002D74"
        d="M60.1,0L0,34.7v69.4l60.1,34.7l60-34.7V34.7L60.1,0z M102.3,93.8l-42.3,24.4L17.8,93.8V45l42.3-24.4L102.3,45 V93.8z"
      />
      <path
        fill="#002D74"
        d="M60.1,138.8l60-34.7V34.7L60.1,0v20.6L102.3,45v48.9l-42.3,24.4V138.8z"
      />
      <path fill="#002D74" d="M60.1,0L0,34.7v69.4l60.1,34.7v-20.5L17.8,93.8V45l42.3-24.4V0z" />
    </svg>
  )
}
